// extracted by mini-css-extract-plugin
export default {"trainAwsPdApplication":"styles_trainAwsPdApplication__Y2rhj","iframeContainer":"styles_iframeContainer__q-qxE"};